import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useCatalogItem, CatalogItem } from './useData';
import { moduleConfig, getDetailSections } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<CatalogItem>
      useData={useCatalogItem}
      config={{
        ...moduleConfig,
        getDetailSections: (item) =>
          getDetailSections(item, moduleConfig.utils.formatDate, moduleConfig.utils.formatCurrency),
      }}
    />
  );
};

export default Detail;
